<template>
  <div>
    <!-- 排课管理 -->
    <div v-if="courseSchedulListSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="courseTypeId" label="">
            <choose-course-type
              ref="chooseCourseTypeRef"
              :disabled="chooseCTdisabled"
              :placeholder="chooseCTplaceholder"
              :org-id="formValidate.schoolIdShow"
              @on-change="handleChooseCourseTypeChange"
            >
            </choose-course-type>
          </FormItem>
          <FormItem prop="orgId" label="">
            <choose-apply
              ref="chooseApplyRef"
              :clearable="true"
              :year-term-code="yearTermCode"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 分班管理 -->
    <div v-if="classListSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg != 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.schoolName"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="selectTypeClassInput"
              placeholder="请输入"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectTypeClass"
                class="search-select-430"
                placeholder="请选择班级名称/ID"
              >
                <Option
                  v-for="(item,index) in selectTypeClassList"
                  :key="item.key+index"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem v-if="!classListDelete" prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="orgId" label="">
            <span v-if="portOrg == 3">{{ userInfo.orgName }}</span>
            <!-- :cacheOrgId="" -->
            <choose-apply
              v-else
              ref="chooseApplyRef"
              :year-term-code="yearTermCode"
              org-type=""
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="formValidate.classType"
              placeholder="请选择课程类型"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="course in courseType"
                :key="'course' + course.value"
                :value="course.value"
              >{{ course.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :clearable="true"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="courseTypeId" label="">
            <choose-course-type
              ref="chooseCourseTypeRef"
              :disabled="chooseCTdisabled"
              :placeholder="chooseCTplaceholder"
              :org-id="formValidate.schoolIdShow"
              @on-change="handleChooseCourseTypeChange"
            >
            </choose-course-type>
          </FormItem>

          <FormItem v-if="!classListDelete" prop="classroomStateShow" label="">
            <Select
              v-model="formValidate.classroomStateShow"
              placeholder="请选择班级状态"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in statusList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="selectTypeInput"
              placeholder="请输入"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectType"
                class="search-select-430"
                placeholder="请选择名称/ID"
              >
                <Option
                  v-for="(item, index) in selectTypeList"
                  :key="index"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem prop="teacherName" label="">
            <Input
              v-model="formValidate.teacherName"
              clearable
              placeholder="请输入负责教师"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="offerOrgType" label="">
            <Select
              v-model="formValidate.offerOrgType"
              placeholder="请选择课程类型"
              clearable
              class="search-select-430"
              style="margin-right: 10px"
            >
              <Option value="1">校内课程</Option>
              <Option value="2">校外课程</Option>
            </Select>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 待分班 -->
    <div v-if="divideIntoClass" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg == 0"
            class="sch-form-item"
            prop="areaCode"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.areaCode"
              placeholder="请选择地区"
              :remote-method="getAreaCodeList"
              :loading="loadingArea"
              :clearable="false"
              @change="handleAreaSelect"
              @visible-change="loadAllList1"
            >
              <el-option
                v-for="(item,index) in areacodeList"
                :key="item.areaCode+index"
                :label="item.areaName"
                :value="item.areaCode"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-if="portOrg == 0"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              :placeholder="
                formValidate.areaCode ? '请选择学校' : '请先选择地区'
              "
              :remote-method="getSchoolListForAreacode"
              :loading="loadingSchool"
              :disabled="!formValidate.areaCode"
              @clear="getSchoolListForAreacode('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-else-if="portOrg != 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.schoolName"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem v-if="portOrg === 0" label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
              @on-init="onCascaderYTInit"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem v-else label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="classData" label="">
            <Cascader
              v-model="formValidate.classData"
              clearable
              :data="gradeAndClassList"
              placeholder="请选择年级班级"
              :change-on-select="true"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="isFirst" label="">
            <Select
              v-model="formValidate.isFirst"
              placeholder="请选择状态"
              class="search-select-430"
            >
              <Option value="-1">全部</Option>
              <Option value="2">离班学生</Option>
              <Option value="1">新报名学生</Option>
            </Select>
          </FormItem>
          <FormItem prop="classroomFee" label="">
            <InputNumber
              v-model="formValidate.classroomFee"
              :min="0"
              class="search-input-430"
              clearable
              placeholder="请输入商品价格"
            ></InputNumber>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="nameListValue"
              placeholder="请输入"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="nameSelectValue"
                placeholder="请选择名称/ID"
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in nameList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select></Input>
          </FormItem>
          <FormItem prop="classType" label="">
            <Select
              v-model="formValidate.classType"
              placeholder="请选择课程分类"
              class="search-select-430"
              clearable
            >
              <Option value="1">素质课</Option>
              <Option value="2">基础托管</Option>
            </Select>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 按学生查询 -->
    <div v-if="studentSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg != 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.schoolName"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>

          <FormItem prop="parentMobile" label="">
            <Input
              v-model="formValidate.parentMobile"
              :maxlength="11"
              clearable
              placeholder="请输入家长手机号"
              class="search-input-430"
              @on-blur="checkParentPhone"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="selectTypeClassInput"
              placeholder="请输入班级名称/ID"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectTypeClass"
                class="search-select-430"
                placeholder="请选择班级名称/ID"
              >
                <Option
                  v-for="item in selectTypeClassList"
                  :key="item.key"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="selectTypeStudentInput"
              placeholder="请输入学生姓名/ID"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectTypeStudent"
                class="search-select-430"
                placeholder="请选择学生姓名/ID"
              >
                <Option
                  v-for="item in selectTypeStudentList"
                  :key="item.key"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 学校课表 -->
    <div v-if="schoolTimeTable" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <slot name="select-sch"></slot>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="courseTypeId" label="">
            <choose-course-type
              ref="chooseCourseTypeRef"
              :disabled="chooseCTdisabled"
              :placeholder="chooseCTplaceholder"
              :org-id="formValidate.schoolIdShow"
              @on-change="handleChooseCourseTypeChange"
            >
            </choose-course-type>
          </FormItem>
          <FormItem prop="yearMap" label="">
            <DatePicker
              v-model="selectMonDate"
              type="month"
              placeholder="请选择月份"
              style="width: 200px"
              :clearable="false"
              transfer
            ></DatePicker>
          </FormItem>
          <Button
            type="primary"
            :disabled="!propSchoolId"
            :loading="loading"
            @click="handleSearch"
          >查询</Button>
          <Button
            class="search-430"
            :loading="loading"
            :disabled="!propSchoolId"
            @click="handleFormData"
          >重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 教师课表 -->
    <div v-if="teacherTimeTable" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem v-if="portOrg === 2" prop="orgId" label="">
            <choose-apply
              ref="chooseApplyRef"
              :year-term-code="yearTermCode"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>

          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="teacherPhone" label="">
            <Input
              v-model="formValidate.teacherPhone"
              :maxlength="11"
              placeholder="请输入教师手机"
              class="search-input-430"
              clearable
              @on-blur="checkPhone"
            ></Input>
          </FormItem>
          <FormItem prop="teacherName" label="">
            <Input
              v-model="formValidate.teacherName"
              placeholder="教师姓名"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <Button
            type="primary"
            :disabled="portOrg !== 2 && !propSchoolId"
            @click="handleSearch"
          >查询</Button>
          <Button
            class="search-430"
            :disabled="portOrg !== 2 && !propSchoolId"
            @click="handleFormData"
          >重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 学生课表 -->
    <div v-if="studentTimeTable" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem prop="classData" label="">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              clearable
              placeholder="请选择年级班级"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <Button
            type="primary"
            :disabled="!propSchoolId"
            @click="handleSearch"
          >查询</Button>
          <Button
            class="search-430"
            :disabled="!propSchoolId"
            @click="handleFormData"
          >重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 班级走向表 -->
    <div v-if="classTimeTableGo" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
        inline
      >
        <Row class="relative" type="flex" flex="end" align="top">
          <FormItem
            v-if="portOrg === 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <Input
              v-model="schoolName"
              clearable
              placeholder="请输入学校"
              :disabled="portOrg === 2"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              placeholder="请选择学期"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
              @getSelectTermName="getTermName"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="branchId" label="">
            <choose-campus
              ref="chooseCampusRef"
              :org-id="formValidate.schoolIdShow"
              :year-term-code="yearTermCode"
              @on-change="handleCampusChange"
            ></choose-campus>
          </FormItem>
          <FormItem prop="gradeId" label="">
            <Select
              v-model="formValidate.gradeId"
              placeholder="请选择年级"
              clearable
              class="search-select-430"
              @on-change="handleChangGradeId"
            >
              <Option
                v-for="(item,index) in getGradesList"
                :key="item.gradeId+index"
                :value="item.gradeId"
              >{{ item.gradeName }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="classIds" label="">
            <Select
              v-model="formValidate.classIds"
              clearable
              placeholder="请选择班级"
              class="search-select-430"
              @on-open-change="getClassesFunc"
            >
              <Option
                v-for="(item,index) in classList"
                :key="item.classId+index"
                :value="item.classId"
              >{{ item.className }}</Option>
            </Select>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
      <div class="flex justify-content_end" style="padding-top: 8px">
        <Button
          class="back"
          type="primary"
          @click="exportMoreHandel"
        >批量导出Excel</Button>
      </div>
    </div>
    <!-- 班级走向表 详情-->
    <div v-if="classTimeTableGoDetail" class="class-search-box">
      <Form ref="searchForm" :model="formValidate" label-position="right">
        <Button
          class="back"
          type="primary"
          @click="exportMoreHandel"
        >导出</Button>
      </Form>
    </div>
    <!-- 智能分班的搜索框 -->
    <div v-if="smartClassSearch" class="class-search-box-division">
      <Form ref="searchForm" :model="formValidate" label-position="right">
        <Row class="relative" type="flex" flex="end">
          <Col class-name="colWidth-430">
            <FormItem label="">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择学期`"
                :cache-year-terms="initYear"
                @on-change="onCascaderChange"
              ></CascaderYearTerms>
            </FormItem>
          </Col>
          <Col
            v-if="portOrg != 2"
            class="sch-form-item"
            class-name="colWidth-430"
          >
            <FormItem prop="schoolId">
              <RemoteSelect
                v-model="formValidate.schoolIdShow"
                placeholder="请选择学校"
                :remote-method="getSchoolList"
                :loading="loadingSchool"
                @clear="getSchoolList('')"
                @change="handleSchoolSelect"
                @visible-change="loadAllList"
              >
                <el-option
                  v-for="(item,index) in schoolList"
                  :key="item.orgId+index"
                  :label="item.schoolName"
                  :value="item.orgId"
                >
                </el-option>
              </RemoteSelect>
            </FormItem>
          </Col>
          <Col v-else class-name="colWidth-430">
            <FormItem prop="schoolIdShow">
              学校：{{ userInfo.orgName }}
            </FormItem>
          </Col>

          <Col class-name="colWidth-430">
            <FormItem>
              <choose-campus
                ref="chooseCampusRef"
                :org-id="formValidate.schoolIdShow"
                @on-change="handleCampusChange"
              ></choose-campus>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="">
              <Button
                :disabled="smartDisAbled"
                type="primary"
                @click="handleSearch"
              >查询</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <!-- 待结算课时数 -->
    <div v-if="waitSettlementClassHours" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg == 0"
            class="sch-form-item"
            prop="areaCode"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.areaCode"
              placeholder="请选择地区"
              :remote-method="getAreaCodeList"
              :loading="loadingArea"
              :clearable="false"
              @change="handleAreaSelect"
              @visible-change="loadAllList1"
            >
              <el-option
                v-for="(item,index) in areacodeList"
                :key="item.areaCode+index"
                :label="item.areaName"
                :value="item.areaCode"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-if="portOrg == 0"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              :placeholder="
                formValidate.areaCode ? '请选择学校' : '请先选择地区'
              "
              :remote-method="getSchoolListForAreacode"
              :loading="loadingSchool"
              :disabled="!formValidate.areaCode"
              @clear="getSchoolListForAreacode('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-else-if="portOrg != 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item,index) in schoolList"
                :key="item.orgId+index"
                :label="item.schoolName"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem v-if="portOrg === 0" label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
              @on-init="onCascaderYTInit"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem v-else label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="classData" label="">
            <Cascader
              v-model="formValidate.classData"
              clearable
              :data="gradeAndClassList"
              placeholder="请选择年级班级"
              :change-on-select="true"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="productName" label="">
            <Input
              v-model="formValidate.productName"
              clearable
              placeholder="请输入课程商品名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="请输入课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import operationAdmin from '@/request/operationAdmin/index.js';
import orderCenterApi from '@/request/orderCenter/index.js';
import common from '@/request/common/index.js';
import courseCenter from '@/request/courseCenter/index.js';
import resourcesManagementApi from '@/request/courseCenter/resources';
import { courseClassList, classroomSubStateList } from '@/utils/dictionary.js';
import { courseTypeData } from '../data/searchBlock.js';
import RemoteSelect from '@c/RemoteSelect';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import { timeToTimestamp } from '@/utils/moment.js';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import ChooseCourseType from '@c/searchBlock/ChooseCourseType.vue';
import ChooseCampus from '@c/searchBlock/ChooseCampus.vue';
import ChooseTerm from '@c/searchBlock/ChooseTerm.vue';
export default {
  components: {
    RemoteSelect,
    CascaderYearTerms,
    ChooseApply,
    ChooseCourseType,
    ChooseCampus,
    ChooseTerm
  },
  props: {
    // 排课管理列表的搜索框
    courseSchedulListSearch: {
      type: Boolean,
      default: false
    },
    // 分班管理列表的搜索框
    classListSearch: {
      type: Boolean,
      default: false
    },
    // 已删除班级列表
    classListDelete: {
      type: Boolean,
      default: false
    },
    // 分班管理-待分班学生列表的搜索框
    divideIntoClass: {
      type: Boolean,
      default: false
    },
    // 分班查询-按学生查询的列表搜索框
    studentSearch: {
      type: Boolean,
      default: false
    },
    // 分班课表-学校列表的搜索框
    schoolTimeTable: {
      type: Boolean,
      default: false
    },
    // 教师课表的搜索框
    teacherTimeTable: {
      type: Boolean,
      default: false
    },
    // 学生课表的搜索框
    studentTimeTable: {
      type: Boolean,
      default: false
    },
    // 走向表
    classTimeTableGo: {
      type: Boolean,
      default: false
    },
    // 走向表详情
    classTimeTableGoDetail: {
      type: Boolean,
      default: false
    },
    // 智能分班搜索框
    smartClassSearch: {
      type: Boolean,
      default: false
    },
    // 父组件传过来的是否可以操作数据
    canOperateData: {
      type: Boolean,
      default: false
    },
    propSchoolId: {
      type: String,
      default: ''
    },
    smartDisAbled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    waitSettlementClassHours: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      courseType: [
        {
          label: '全部课程类型',
          value: -1
        },
        {
          label: '素质课',
          value: 1
        },
        {
          label: '基础托管',
          value: 2
        }
      ],
      portOrg: -1,
      getGradesList: [],
      classList: [],
      // termId: '',

      formValidate: {

        schoolId: null, // 学校id
        schoolIdShow: -1, // 学期id 默认全部
        branchId: null, // 校区id
        // termIdShow: 'all', // 学期id 默认全部
        yearName: '全部',
        // termId: null, // 学期id （走向表）
        classIds: null, // 班级id （走向表）
        // classType: '0', // 课程类别id
        courseTypeId: null, // 课程分类id
        orgId: null, // 提供方id
        relClassroomName: null, // 商品名称
        relClassroomId: null, // 商品id
        classroomName: null, // 班级名称
        classroomId: null, // 班级id
        classroomStateShow: 'all',
        courseStateList: null, // 班级状态
        classData: [], // 年级班级信息
        gradeId: null, // 年级id
        classId: null, // 班级id
        studentId: null, // 学生id
        studentName: null, // 学生姓名
        parentMobile: null, // 家长手机号
        teacherPhone: null, // 教师手机
        teacherName: null, // 教师姓名/ID
        teacherId: null,
        classroomFee: null, // 商品价格
        isFirst: '-1', // 1 初次报名 2离班过学生
        // classroomId: '', // 商品id
        classType: -1, // 课程类型
        productName: null,
        offerOrgType: null// 1学校 2机构
      },
      schoolIdElectShow: true,
      gradeIdElectShow: true,
      selectType: '1', // 选择的种类
      selectTypeInput: '', // 选择种类之后输入的
      nameListValue: '',
      nameSelectValue: 'classroomName',
      nameList: [
        { label: '商品名称', value: 'classroomName' },
        { label: '商品ID', value: 'classroomId' }

        // { label: '资源ID', value: 'courseId' }
      ],
      selectTypeList: [
        {
          name: '商品名称',
          key: '1'
        },
        {
          name: '商品ID',
          key: '2'
        }
      ],
      loadingSchool: false,
      schoolList: [], // 学校列表
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      // termList: [],
      courseClassList: courseClassList, // 课程类别
      loadingCourse: false, //
      courseTypeList: [], // 课程分类
      loadingApply: false,
      applyList: [], // 提供方列表
      statusList: [],
      gradeAndClassList: [], // 年级班级列表
      classlList: [], // 班级列表
      selectTypeClassInput: '', // 输入的
      selectTypeClass: '1', // 选择种类之后输入的
      selectTypeClassList: [
        {
          name: '班级名称',
          key: '1'
        },
        {
          name: '班级ID',
          key: '2'
        }
      ],
      selectTypeStudentInput: '',
      selectTypeStudent: '1',
      selectTypeStudentList: [
        {
          name: '学生名称',
          key: '1'
        },
        {
          name: '学生ID',
          key: '2'
        }
      ],
      selectTypeOrgIdSelect: '',
      selectTypeOrg: '1',
      selectTypeOrgList: [
        {
          name: '学校',
          key: '1'
        },
        {
          name: '提供方',
          key: '2'
        }
      ],
      schoolName: '',
      num: 0,
      //  courseTypeListData: [...courseTypeData],
      courseTypeL: [],
      selectMonDate: new Date(), // 选择哪个月份
      dataChange: 0,
      branchChange: 0, // 校区更改
      initYear: [],
      yearTermCode: [],
      loadingArea: false,
      areacodeList: []
    };
  },
  computed: {
    ...mapState(['userInfo']),
    // 课程分类组件 占位符
    chooseCTplaceholder() {
      return this.formValidate.schoolIdShow === '' ||
        this.formValidate.schoolIdShow === -1
        ? '请先选择学校'
        : '请选择课程分类';
    },
    // 课程分类组件 禁止状态
    chooseCTdisabled() {
      return (
        this.formValidate.schoolIdShow === '' ||
        this.formValidate.schoolIdShow === -1
      );
    }
  },
  watch: {
    propSchoolId: {
      handler(newVal) {
        console.log(newVal, '拿到最新的id');
        this.formValidate.schoolIdShow = this.propSchoolId;
        this.schoolIdElectShow = false;
        // 不是  班级走向表 和 排课管理列表的搜索框
        if (!this.classTimeTableGo && !this.courseSchedulListSearch) {
          this.selectTypeInput = '';
          this.selectTypeClassInput = '';
          this.selectTypeStudentInput = '';
          // this.$refs['searchForm'].resetFields();
          this.formValidate.classType = '0';
          this.judgePortAndBlock();
        }

        if (this.classTimeTableGo) {
          this.formValidate.gradeId = '';
          this.formValidate.classIds = '';
          this.getGradesFunc();
        }

        this.handleSchoolSelect(this.propSchoolId);
      },
      immediate: true
    },
    'formValidate.schoolId': {
      handler(newval, oldVal) {
        this.$refs.chooseCourseTypeRef &&
          this.$refs.chooseCourseTypeRef.handleClear();
      },
      immediate: true,
      deep: true
    },

    'formValidate.schoolIdShow': {
      handler(newVal, oldVal) {
        console.log(newVal, '=====6456464====');
        this.courseTypeL = [];
        // this.courseTypeListData = [...courseTypeData];
        this.formValidate.classType = null;
        this.formValidate.courseTypeKind = null;
        this.formValidate.courseTypeId = null;
        this.$refs.chooseCourseTypeRef &&
          this.$refs.chooseCourseTypeRef.handleClear();
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    if (this.portOrg === 0 && (this.divideIntoClass || this.waitSettlementClassHours)) {
      // this.formValidate.areaCode = '';
      this.getAreaCodeList();
    }
    // 分班管理列表
    if (this.classListSearch) {
      this.dealStatusList();
    }

    // 课程类型
    if (this.classListSearch && this.$route.query.oType) {
      this.formValidate.classType = parseInt(this.$route.query.oType);
    }
    // this.classListSearch &&
    if (this.$route.query.yearCode && this.$route.query.termCode) {
      this.initYear[0] = Number(this.$route.query.yearCode);
      this.initYear[1] = this.$route.query.termCode;
    }
  },
  mounted() {

  },
  methods: {
    async getAreaCodeList(query) {
      this.loadingArea = true;
      const params = {};
      query ? params.searchStr = query : '';
      const res = await common.getListAreaCodeApi(params);
      if (res.status === 200) {
        this.areacodeList = res.message.list ? res.message.list : [];
        if (!this.formValidate.areaCode && this.areacodeList.length > 0) {
          const areaCode = localStorage.getItem('areaCodeForLeaveListSearch') ? localStorage.getItem('areaCodeForLeaveListSearch') : this.areacodeList[0].areaCode;
          const areaName = localStorage.getItem('areaNameForLeaveListSearch') ? localStorage.getItem('areaNameForLeaveListSearch') : this.areacodeList[0].areaName;
          const findResult = this.areacodeList.findIndex(item => {
            return item.areaCode === areaCode;
          });
          findResult === -1 ? this.areacodeList.unshift({
            areaCode,
            areaName
          }) : '';
          localStorage.setItem('areaCodeForLeaveListSearch', areaCode);
          localStorage.setItem('areaNameForLeaveListSearch', areaName);
          this.formValidate.areaCode = areaCode;
        }
        this.loadingArea = false;
        this.portOrg === 0 ? this.getSchoolListForAreacode() : '';
        console.log(this.formValidate.areaCode, '拿到的区域id');
        this.handleSearch();
      }
    },
    // 通过地区编码获取
    async getSchoolListForAreacode(query) {
      this.loadingSchool = true;
      const params = {
        areaCode: this.formValidate.areaCode,
        pageNum: 1,
        pageSize: 20
      };
      query ? params.searchStr = query : '';
      const res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        this.schoolList = res.message.list ? res.message.list : [];
        this.schoolList.unshift({
          schoolId: -1,
          schoolName: '全部',
          orgId: -1,
          name: '全部学校'
        });
      }
    },
    handleAreaSelect(option) {
      if (!option) {
        return;
      }
      this.formValidate.areaCode = option;
      localStorage.setItem('areaCodeForLeaveListSearch', this.formValidate.areaCode);
      const findResult = this.areacodeList.findIndex(item => {
        return item.areaCode === this.formValidate.areaCode;
      });
      findResult > -1 ? localStorage.setItem('areaNameForLeaveListSearch', this.areacodeList[findResult].areaName) : '';
      this.formValidate.schoolId = null;// 学校id
      this.formValidate.schoolIdShow = -1; // 学校id 默认全部
      this.formValidate.classData = [];
      this.gradeAndClassList = [];
      this.$forceUpdate();
      this.portOrg == 0 ? this.getSchoolListForAreacode() : '';
    },
    loadAllList1(val) {
      if (!val) {

      }
    },
    cutSchoolByParent(data) {
      this.schoolList = [
        {
          orgId: data.schoolId,
          name: data.schoolName
        }
      ];
      this.$eventHub.$emit('pushChangeSchool', {
        id: data.schoolId,
        name: data.schoolName,
        orgId: data.schoolId
      });

      this.$nextTick(() => {
        this.handleSchoolSelect(data.schoolId);
        this.handleSearch();
      });
    },
    dealStatusList() {
      const statusList = [
        {
          label: '全部班级状态',
          value: 'all'
        }
      ];
      this.statusList = statusList.concat(classroomSubStateList);
    },
    // 不同端口与不同模块请求不同的接口
    judgePortAndBlock() {
      // 学校端
      if (this.portOrg === 2) {
        this.schoolIdElectShow = false;
        this.formValidate.schoolIdShow = this.userInfo.orgId;
        this.formValidate.schoolId = this.userInfo.orgId;
        this.schoolName = this.userInfo.orgName;

        this.divideIntoClass || this.studentTimeTable || this.waitSettlementClassHours
          ? this.getGradeAndClass()
          : '';
      } else if (this.portOrg === 3 && this.classListSearch) {
        this.getSchoolList();

        this.formValidate.orgId = this.userInfo.orgId;
      } else {

        // 除了分班管理下的 学校，教师，学生，班级走向表 课表，其他的要请求学校接口
        // if (!this.schoolTimeTable&&!this.studentTimeTable&&!this.classTimeTableGo&&!this.teacherTimeTable) {
        //   this.getSchoolList();
        // }

        // 分班管理下的学生课表 请求 年级班级接口
        // if (this.studentTimeTable && this.formValidate.schoolIdShow) {
        //   this.getGradeAndClass();
        // }
      }
    },
    /** ***** 有关学校列表的操作 start  ********/
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    // 获取学校列表
    getSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = {
        orgName: query,
        yearCode: this.formValidate.yearCode,
        termCode: this.formValidate.termCode,
        orgType: 1
      };
      this.getSchoolListAdmin(queryTrue);
    },
    // 请求学校列表(运营端,教育局端,机构端)
    async getSchoolListAdmin(query) {
      const params = Object.assign(this.schoolPageInfo, query);
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.schoolId = item.orgId;
          item.schoolName = item.name || item.orgName;
          return item;
        });
        if (!this.courseSchedulListSearch && !this.smartClassSearch) {
          this.schoolList.unshift({
            schoolId: -1,
            schoolName: '全部学校',
            orgId: -1,
            name: '全部学校'
          });
        }
        this.schoolPageInfo.total = Number(res.message.total);
        this.loadingSchool = false;
      }
    },
    // 处理 选择学校 iview select 问题
    handleSelectSchHack() {
      this.$nextTick(() => {
        if (this.num < 2) {
          try {
            const dom = document
              .getElementsByClassName('sch-form-item')[0]
              .getElementsByClassName('ivu-select-item-selected')[0];
            dom.click();
          } catch (err) {
          }
        }
        this.num++;
      });
    },
    // 当选择了某个学校之后，就去请求校区数据(列表)请求年级班级列表（学生查询）
    handleSchoolSelect(option) {
      if (!option) {
        return;
      }
      this.schoolIdElectShow = false;
      // this.formValidate.schoolIdShow = option;
      // this.formValidate.schoolId = option;
      //

      // 待分班学校 请求 年级班级
      if (this.divideIntoClass || this.waitSettlementClassHours) {
        this.getGradeAndClass();
      }
    },
    // 学期
    perChange(e) {
      if (e) {
        this.formValidate.yearName = e.label;
      }
    },
    // 校区选择branchId
    handleCampusChange(val) {
      this.formValidate.branchId = val;
      this.branchChange++;
      if (this.smartClassSearch && this.formValidate.yearCode && this.branchChange == 1) {
        this.handleSearch();
      }
    },
    // 年级列表
    async getGradesFunc() {
      console.log(this.formValidate['schoolId'], '拿到的---', this.propSchoolId);
      if (this.propSchoolId == '' && this.formValidate['schoolIdShow'] == '') {
        return;
      }

      const params = {
        schoolId: this.propSchoolId ? this.propSchoolId : this.formValidate['schoolIdShow']
      };

      const res = await this.$http.getGrades(params);
      if (res.status == 200) {
        this.getGradesList = res.message;
      }
    },
    // 班级列表
    async getClassesFunc(status) {
      if (!this.formValidate.gradeId) {
        return null;
      }
      if (status) {
        const params = {
          schoolId: this.formValidate.schoolIdShow,
          gradeId: this.formValidate.gradeId
        };
        const res = await this.$http.getClasses(params);
        if (res.status == 200) {
          this.classList = res.message;
        }
      }
    },
    /** ***** 有关学期的操作 end  ********/
    /** ***** 有关课程类别的操作 start  ********/
    // 选择课程类别之后，请求课程分类列表
    handleCourseClassSelect(option) {
      this.formValidate.classType = option.value;
      this.getCourseTypeList();
    },
    /** ***** 有关课程类别的操作 end  ********/
    /** ***** 有关课程分类的操作 start  ********/
    // 获取课程分类列表
    async getCourseTypeList(query) {
      const params = {
        pageNum: 1,
        pageSize: 100,
        classType: this.formValidate.classType
      };
      this.formValidate.schoolIdShow
        ? (params.orgId = this.formValidate.schoolIdShow)
        : '';
      this.loadingCourse = true;
      query && query.length > 1 ? (params.courseTypeName = query) : '';
      const res = await operationAdmin.getCourseTypeList(params);
      if (res.status === 200) {
        this.courseTypeList = res.message.list;
        // this.courseTypeList = [];
        this.loadingCourse = false;
      }
    },
    // 自定义级联显示内容
    format(labels, selectedData) {
      return labels.join('-');
    },
    // 课程分类 组件 on-change 事件
    handleChooseCourseTypeChange(types) {
      const { courseTypes, classType, courseTypeKind, courseTypeId } = types;
      this.formValidate.classType = classType;
      this.formValidate.courseTypeKind = courseTypeKind;
      this.formValidate.courseTypeId = courseTypeId;
      this.courseTypeL = courseTypes;
    },
    // 提供方组件值改变
    handleOnApplyChange(val) {
      this.formValidate.orgId = val.orgId;
    },
    // 选择年级之前，先看有没有选学校
    handleGradeSelect(status) {
      console.log(this.formValidate.schoolIdShow, 'nadaode---');
      if (status && (this.formValidate.schoolIdShow === '' || +this.formValidate.schoolIdShow === -1)) {
        return this.$Message.error('请先选择学校！');
      }
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      if (this.formValidate.schoolIdShow == -1) return;
      const params = {
        schoolId: this.formValidate.schoolIdShow
      };
      console.log('年级班级接口');
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    /** ***** 有关年级班级的操作 end  ********/
    // 校验手机号码
    checkPhone() {
      if (!this.formValidate.teacherPhone) {
        return false;
      }
      const reg = /^(1)\d{10}/;
      if (!reg.test(this.formValidate.teacherPhone)) {
        this.$Message.error('请输入正确手机号！');
        this.formValidate.teacherPhone = null;
      }
    },
    checkParentPhone() {
      if (!this.formValidate.parentMobile) {
        return null;
      }
      const reg = /^(1)\d{10}/;
      if (!reg.test(this.formValidate.parentMobile)) {
        this.$Message.error('请输入正确手机号！');
        this.formValidate.parentMobile = null;
      }
    },
    /** ***** 有关学期的操作 start  ********/
    onCascaderYTInit() {
      // this.handleSearch();
    },
    getTermName(name) {
      console.log(name, '拿到的学期名称----');
      this.formValidate.yearName = name;
    },
    async onCascaderChange(v) {
      console.log('onCascaderChange', '执行款选择日期---', v);
      this.yearTermCode = v;
      localStorage.setItem('yearTermCode', this.yearTermCode);
      this.formValidate.yearCode = v.length ? v[0] : '';
      this.formValidate.termCode = v.length ? v[1] : '';
      if (this.classTimeTableGo) {
        //    this.getGradesFunc();

      }
      if (this.portOrg === 0 && (this.divideIntoClass || this.waitSettlementClassHours)) {
        return;
      }
      // 排课管理，课程，学校，学生，班级课表（走向表）都要根据学期的变化请求最外层的学校的变化
      if (this.courseSchedulListSearch || this.teacherTimeTable || this.studentTimeTable || this.classTimeTableGo || this.schoolTimeTable) {
        if (this.portOrg !== 2) {
          this.$eventHub.$emit('changeYearTermCode', this.yearTermCode);
        } else {
          await this.judgePortAndBlock();
        }

        // 分班管理下的学生课表 请求 年级班级接口 运营端的 0
        if (this.studentTimeTable && this.formValidate.schoolIdShow && this.portOrg == 0) {
          this.getGradeAndClass();
        }
      } else {
        // 学校端
        if (this.portOrg == 2) {
          await this.judgePortAndBlock();
        } else {
          this.formValidate.schoolIdShow = -1;
          this.formValidate.orgId = '';
          this.schoolPageInfo.total = 0;
          await this.getSchoolList();
        }
      }

      this.dataChange++;

      if (this.dataChange === 1) {
        this.portOrg === 2
          ? (this.formValidate.schoolId = this.userInfo.orgId)
          : '';
        if (this.smartClassSearch) {
          if (this.formValidate.branchId) {
            this.handleSearch();
          }
        } else {
          this.handleSearch();
        }
      }
    },
    // 点击查询按钮
    handleSearch() {
      if (!this.courseSchedulListSearch) {
        this.formValidate.schoolId =
          this.formValidate.schoolIdShow === -1
            ? null
            : this.formValidate.schoolIdShow;
      }

      if (this.classListSearch) {
        this.formValidate.relClassroomName = null;
        this.formValidate.relClassroomId = null;
        this.formValidate.classroomName = null;
        this.formValidate.classroomId = null;
        this.formValidate.yearName = '';
        switch (this.selectTypeClass) {
          case '1':
            this.formValidate.classroomName = this.selectTypeClassInput
              ? this.selectTypeClassInput
              : null;
            break;
          case '2':
            this.formValidate.classroomId = this.selectTypeClassInput
              ? this.selectTypeClassInput
              : null;
            break;
          default:
            break;
        }
        switch (this.selectType) {
          case '1':
            this.formValidate.relClassroomName = this.selectTypeInput
              ? this.selectTypeInput
              : null;
            break;
          case '2':
            this.formValidate.relClassroomId = this.selectTypeInput
              ? this.selectTypeInput
              : null;
            break;
          default:
            break;
        }
      }
      if (this.studentSearch) {
        this.formValidate.classroomName = null;
        this.formValidate.classroomId = null;
        this.formValidate.studentName = null;
        this.formValidate.studentId = null;
        switch (this.selectTypeClass) {
          case '1':
            this.formValidate.classroomName = this.selectTypeClassInput
              ? this.selectTypeClassInput
              : null;
            break;
          case '2':
            this.formValidate.classroomId = this.selectTypeClassInput
              ? this.selectTypeClassInput
              : null;
            break;
          default:
            break;
        }
        switch (this.selectTypeStudent) {
          case '1':
            this.formValidate.studentName = this.selectTypeStudentInput
              ? this.selectTypeStudentInput
              : null;
            break;
          case '2':
            this.formValidate.studentId = this.selectTypeStudentInput
              ? this.selectTypeStudentInput
              : null;
            break;
          default:
            break;
        }
      }

      if (this.divideIntoClass) {
        this.formValidate.classroomName = '';
        this.formValidate.classroomId = '';
        switch (this.nameSelectValue) {
          case 'classroomName':
            this.formValidate.classroomName = this.nameListValue;
            break;
          case 'classroomId':
            this.formValidate.classroomId = this.nameListValue;
            break;
        }
      }
      // 年级班级信息修改

      this.formValidate.courseStateList =
        this.formValidate.classroomStateShow === 'all'
          ? null
          : this.formValidate.classroomStateShow;
      if (!this.classTimeTableGo) {
        if (this.formValidate.classData.length) {
          this.formValidate.gradeId = this.formValidate.classData[0];
          this.formValidate.classId = this.formValidate.classData[1];
        } else {
          this.formValidate.gradeId = null;
          this.formValidate.classId = null;
        }
      }

      if (this.divideIntoClass || this.waitSettlementClassHours) {
        if (this.formValidate.gradeId) {
          this.formValidate.gradeName = this.getGradeName(this.formValidate.gradeId);
        } else {
          this.formValidate.gradeName = '';
        }
        if (this.formValidate.classId) {
          this.formValidate.className = this.getClassName(this.formValidate.classId);
        } else {
          this.formValidate.className = '';
        }
        this.formValidate.gradeId = '';
        this.formValidate.classId = '';
      }
      if (this.schoolTimeTable) {
        this.$emit(
          'getSearchValue',
          this.formValidate,
          new Date(this.selectMonDate).Format('yyyy-MM')
        );
      } else {
        this.$emit('getSearchValue', this.formValidate);
      }
    },
    getGradeName(gradeId) {
      const key = this.gradeAndClassList.findIndex(item => {
        return item.value == gradeId;
      });

      return this.gradeAndClassList[key]['label'];
    },
    getClassName(classId) {
      const key = this.gradeAndClassList.findIndex(item => {
        return item.value == this.formValidate.gradeId;
      });
      const classKey = this.gradeAndClassList[key]['children'].findIndex(item => {
        return item.value == classId;
      });

      return this.gradeAndClassList[key]['children'][classKey]['label'];
    },
    emitData() {
      this.$emit('input', this.formValidate);
    },
    // 重置表单数据
    handleFormData() {
      this.courseTypeL = [];
      // this.courseTypeListData = [...courseTypeData];
      this.formValidate.classType = null;
      this.formValidate.courseTypeKind = null;
      this.formValidate.courseTypeId = null;
      this.selectTypeInput = '';
      this.selectTypeClassInput = '';
      this.selectTypeStudentInput = '';
      this.$refs['searchForm'].resetFields();
      this.formValidate.classType = '0';
      this.formValidate.classroomName = '';
      this.selectMonDate = new Date();
      this.formValidate.isFirst = -1;
      this.formValidate.classroomId = '';
      this.nameListValue = '';
      this.formValidate.classroomFee = null;
      if ((this.divideIntoClass || this.waitSettlementClassHours) && +this.portOrg !== 2) {
        // this.formValidate.areaCode = this.areacodeList[0]['areaCode'];
        this.formValidate.areaCode = localStorage.getItem('areaCodeForLeaveListSearch') ? localStorage.getItem('areaCodeForLeaveListSearch') : this.areacodeList[0]['areaCode'];
      }

      // if (this.classListSearch) {
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      // }'
      if (yearTerms.length) {
        this.formValidate.yearCode = yearTerms[0];
        this.formValidate.termCode = yearTerms[1];

        this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
        this.$refs.chooseCourseTypeRef &&
          this.$refs.chooseCourseTypeRef.handleClear();
        if (this.portOrg !== 2) {
          this.schoolIdElectShow = true;
        }

        this.gradeIdElectShow = true;
        // 走向表
        if (this.classTimeTableGo) {
          // const resetFields = true;
          // this.$emit('handleFormData', resetFields);
          this.handleSearch();
        } else {
          this.handleSearch();
          this.$emit('cleanFormData');
          this.judgePortAndBlock();
        }
      }
    },
    // 选择年级
    handleChangGradeId() {
      if (this.formValidate.gradeId) {
        this.gradeIdElectShow = false;
      } else {
        this.gradeIdElectShow = true;
      }
      this.formValidate.classIds = '';
      this.classList = [];
    },
    // 批量导出
    exportMoreHandel() {
      this.$emit('handleExportMore');
    },
    handleQueryChange(v) {
      if (v === '') {
        this.formValidate.schoolIdShow = '';
      }
    },
    handleExportList() {
      this.$emit('handleExportList', this.formValidate);
    }
  }
};
</script>
<style lang="scss" scoped>
.class-search-box-division {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 16px;
}
.btn-box {
  // display: flex;
  // vertical-align: center;
  button + button {
    margin-left: 16px;
  }
  .btn {
    margin-left: 16px;
    font-size: 16px;
  }
}
.select-big {
  display: flex;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  /deep/.ivu-select-selection {
    border: none;
  }
  /deep/.ivu-input {
    border: none;
    border-radius: 0;
    border-left: 1px solid #dcdee2;
  }
  /deep/.ivu-input:focus {
    box-shadow: none;
  }
}
.select-big-apply {
  display: flex;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  /deep/.ivu-select-selection {
    border: none;
  }
  /deep/.ivu-select-selection:nth-of-type(2) {
    border: none;
    border-radius: 0;
    border-left: 1px solid #dcdee2;
  }
  /deep/.ivu-select-selection:focus {
    box-shadow: none;
  }
}
.page-box {
  padding: 0 16px;
}
.slot-box {
  margin-bottom: 16px;
}
.w-25 {
  width: 100px;
}
/deep/ .ivu-form-item-content {
  line-height: normal;
}
</style>
